export const stringOrEmptyString = (str) => {
  return str !== undefined && str !== null && str.length > 0 ? String(str) : '';
};
